export default __webpack_public_path__ + "static/media/logo.1d5e37e2.svg";